export const toggleDrawer = (open) => ({
  type: 'TOGGLE_DRAWER',
  payload: open,
});
